import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  quote: string;
  age?: number;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote,
  age
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-31">
      <div className="flex gap-1 mb-4" data-id="element-32">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-33" />)}
      </div>
      <blockquote className="flex-grow mb-6" data-id="element-34">
        <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-35">
          "{quote}"
        </p>
      </blockquote>
      <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-36">
        <p className="font-bold text-gray-900" data-id="element-37">
          {name}
          {age ? `, ${age}` : ''}
        </p>
        <p className="text-sm text-indigo-600 font-medium" data-id="element-38">{role}</p>
        <p className="text-xs text-gray-500" data-id="element-39">{location}</p>
      </div>
    </div>;
}